import { render } from "./ApprovalStatusPopUp.vue?vue&type=template&id=a8d1564e&scoped=true"
import script from "./ApprovalStatusPopUp.vue?vue&type=script&lang=js"
export * from "./ApprovalStatusPopUp.vue?vue&type=script&lang=js"

import "./ApprovalStatusPopUp.vue?vue&type=style&index=0&id=a8d1564e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d1564e"]])

export default __exports__